import { Treatment } from "@hooks/useGetRecommendation";
import Prescription from "./Treatment";
import PlusIcon from "@assets/icons/plus_text.svg";
import styled from "styled-components";
import { Fragment } from "react/jsx-runtime";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const Treatments = ({
  treatments,
  isAdult,
}: {
  treatments: Treatment[] | undefined;
  isAdult: boolean;
}) => {
  return (
    <Container>
      {treatments?.map(({ treatment }, i) => (
        <Fragment key={treatment?.titleDisplay}>
          <Prescription treatment={treatment} isAdult={isAdult} />
          {i !== treatments.length - 1 && <PlusIcon />}
        </Fragment>
      ))}
    </Container>
  );
};

export default Treatments;
